import { EAnswersActionTypes } from '../../actions/answers';
import { IAnswers, TReduxActions } from '../../types/redux';
import { mapLikeAndDislikeReaction } from '../../mappers/LikeAndDislikeReaction';

export const defaultAnswersState: IAnswers = {};

export function answersReducer(state: IAnswers = defaultAnswersState, action: TReduxActions) {
  switch (action.type) {
    case EAnswersActionTypes.SetAnswers: {
      return {
        ...state,
        ...action.payload,
      };
    }

    case EAnswersActionTypes.SetAnswerReaction: {
      return {
        ...state,
        [action.payload.answerId]: {
          ...state[action.payload.answerId],
          like: mapLikeAndDislikeReaction({
            currentState: state[action.payload.answerId].like,
            nextState: action.payload.type,
          }),
        },
      };
    }

    default:
      return state;
  }
}
